import React, {Component} from 'react';
import * as firebase from 'firebase';
import FontAwesome from 'react-fontawesome';
import ImageUploader from '../image-uploader/image-uploader';
import './stage-editor.css';

/** @class FrameList
  * A component for editing the frames in an AnimationLayer
  */
export default class FrameList extends Component {
  /** @constructor
    * Creates a new instance of FrameList
    */
  constructor(props) {
    super(props);
    this.state = {frames: []}
    this.firebaseRef = firebase.database().ref(props.dataURL);
    this.addFrame = this.addFrame.bind(this);
    this.removeFrame = this.removeFrame.bind(this);
    this.handleImageUpload = this.handleImageUpload.bind(this);
  }
  /** @function componentWillMount
    * Connects the component with the corresponding
    * database entry.
    */
  componentWillMount() {
    this.firebaseRef.on('value', snapshot => {
      var frames = [];
      snapshot.forEach(child => {
        frames.push({
          data: child.val(),
          dataURL: `${this.props.dataURL}/${child.key}`
        });
      });
      this.setState({frames: frames})
    });
  }
  /** @function componentWillUnmount
    * Disconnects component from the database.
    */
  componentWillUnmount() {
    this.firebaseRef.off();
  }
  /** @function addFrame
    * Adds a new frame to the frame list.
    */
  addFrame() {
    firebase.database().ref(this.props.dataURL)
      .push({image: 'http://via.placeholder.com/200x200'});
  }
  /** @function removeFrame
    * Removes the specified frame from the database,
    * and any associated images from Firebase storage.
    * @param {url} dataURL - the firebase url to remove
    */
  removeFrame(dataURL) {
    firebase.storage().ref().child(dataURL).delete();
    firebase.database().ref(dataURL).remove();
  }
  /** @function handleImageUpload
    * Replaces the image url for a frame in the database.
    * @param {url} dataURL - the firebase url to update
    * @param {url} url - the new image source
    */
  handleImageUpload(dataURL, url) {
    firebase.database().ref(dataURL).set({image: url});
  }
  /** @function render
    * Renders the component.
    */
  render() {
    const frames = this.state.frames.map((frame,i) => {
      return(
      <div key={"frame-"+i} className="frame">
        <ImageUploader name={"Frame " + (i+1)}
          value={frame.data.image}
          dataURL={frame.dataURL}
          onUpload={((url) => this.handleImageUpload(frame.dataURL, url))}
          />
        <button onClick={()=>this.removeFrame(frame.dataURL)}>
          <FontAwesome name="times" style={{color: "red"}} />
          Remove Frame
        </button>
      </div>
    )});
    return (
      <div>
        {frames}
        <button onClick={this.addFrame}>
          Add Frame
        </button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/stage-editor/frame-list.js